
const local = {
  "aws_project_region": "us-east-1",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_YSWpMDglG",
  "aws_user_pools_web_client_id": "3tg9nc8ajq23s5bjvnfd3p1739",
}

const dev = {
  "aws_project_region": "us-east-1",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_YSWpMDglG",
  "aws_user_pools_web_client_id": "3tg9nc8ajq23s5bjvnfd3p1739",
}

const prod = {
  "aws_project_region": "us-east-1",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_SL8FNxHbU",
  "aws_user_pools_web_client_id": "3ec6o8lmf71c5bevk5j8siur5j",
}

const awsconfig = process.env.REACT_APP_ENV === 'prod'
? prod 
: process.env.REACT_APP_ENV === 'dev'
? dev
: local;

export default awsconfig;